import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Pensé que tenía que bajar 10 kilos para volver a usar mis blusas favoritas. Con el sistema de capas mi abdomen desapareció visualmente. Me siento completamente otra persona.',
    name: 'María Beatriz',
    location: 'Miami FL',
    initial: 'M',
    image: 'https://cdn.magicpatterns.com/uploads/xc3um4FjcReFSrTMcqQUk7/thumb.png'
  }, {
    quote: 'Lo que más me transformó fue la regla de los tercios. Siempre me vestía 50/50 y me veía cuadrada y bajita. Ahora mis piernas se ven larguísimas con los mismos jeans de siempre.',
    name: 'Tiffany',
    location: 'Houston TX',
    initial: 'T',
    image: 'https://cdn.magicpatterns.com/uploads/1sMejRyGkCjfssLqxwyCAF/thumb.png'
  }, {
    quote: 'Por fin entendí por qué la ropa de Instagram no me quedaba igual que a las influencers. Este PDF me ahorró cientos de dólares en ropa que no necesitaba. Ojalá lo hubiera tenido hace 5 años.',
    name: 'Carmen Cecilia',
    location: 'Dallas TX',
    initial: 'C',
    image: 'https://cdn.magicpatterns.com/uploads/28Pxon7MPrxLnEsGSsQ6X3/thumb.jpg'
  }];
  return <section className="bg-brand-primary/15 py-12 sm:py-16 px-4" data-id="element-194">
      <div className="max-w-content mx-auto" data-id="element-195">
        <FadeIn data-id="element-196">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center text-brand-text mb-10" data-id="element-197">
            Lo que dicen las mujeres que ya lo aplicaron
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 gap-6" data-id="element-198">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-199">
              <div className="bg-white border border-brand-accent/20 rounded-2xl p-6 sm:p-8 shadow-sm relative" data-id="element-200">
                <div className="flex gap-1 mb-4" data-id="element-201">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5" style={{
                fill: '#FACC15',
                color: '#FACC15'
              }} data-id="element-202" />)}
                </div>

                <p className="text-brand-text/80 italic mb-6 leading-relaxed text-lg" data-id="element-203">
                  "{t.quote}"
                </p>

                <div className="flex items-center gap-4" data-id="element-204">
                  {t.image ? <div className="w-12 h-12 rounded-full overflow-hidden border border-brand-accent/30 flex-shrink-0" data-id="element-205">
                      <img src={t.image} alt={t.name} className="w-full h-full object-cover" data-id="element-206" />
                    </div> : <div className="w-12 h-12 rounded-full bg-brand-primary/20 flex items-center justify-center border border-brand-accent/30" data-id="element-207">
                      <span className="text-brand-accent font-serif font-bold text-xl" data-id="element-208">
                        {t.initial}
                      </span>
                    </div>}
                  <div data-id="element-209">
                    <p className="font-bold text-brand-text" data-id="element-210">{t.name}</p>
                    <p className="text-sm text-brand-text/60" data-id="element-211">{t.location}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}